import $ from 'jquery';
document.addEventListener( 'DOMContentLoaded', function() {
  let giveFormLabel = document.querySelectorAll( '.donation-form__label' ), i;

  for( i = 0; i < giveFormLabel.length; ++i ) {
    let el = giveFormLabel[i];
    el.addEventListener('click', function() {
      let formLabel;
      if( document.querySelector( '.donation-form__label--active' ) ) {
        formLabel = document.querySelector( '.donation-form__label--active' );
        formLabel.classList.remove('donation-form__label--active');
      }
      el.classList.add('donation-form__label--active');
    })
  }
});
document.addEventListener( 'DOMContentLoaded', function() {
  let giveFormLabel = document.querySelectorAll( '.donation-form__input' ), i;

  for( i = 0; i < giveFormLabel.length; ++i ) {
    let el = giveFormLabel[i];
    el.addEventListener('click', function() {
      let formLabel;
      if( document.querySelector( '.donation-form__input--active' ) ) {
        formLabel = document.querySelector( '.donation-form__input--active' );
        formLabel.classList.remove('donation-form__input--active');
      }
      el.classList.add('donation-form__input--active');
    })
  }
});



var buttonAmount    = $('.donation-form__input--active');
var customAmount    = $('.donation-form__input--custom');
var buttonDonate    = $('#button-donate');
var frequencyButton = $('.donation-form__label--active');
var url = 'https://seachange.giv.sh/f668/';
var value;
var frequency = "";

// Toggling amount
buttonAmount.on('change', function() {
    $('.donation-form__input').val();
});

// Resetting amounts and setting the custom-amount
customAmount.on('change', function() {
    customAmount.data( 'amount', customAmount.val() );
});

buttonDonate.on( 'click', function(e) {
  e.preventDefault();

  let inputActive = document.querySelector('.donation-form__input--active');
  if(customAmount.val()) {
    value = customAmount.val();
  }
  else if(inputActive) {
    value = document.querySelector('.donation-form__input--active').dataset.amount;
  }
  else {
    // No values are selected
    return;
  }


  var monthly = document.querySelector('.donation-form__label--active.donation-form__label--monthly');
  if(monthly) {
    frequency = "&interval=monthly";
  }

  var finalURL = `${url}?amount=${value}${frequency}`;
  location.assign(finalURL);
});
